import { Card, CardBody, Col, Input } from "reactstrap";
import { FormControlSizingTitle } from "../../../../../constants";
import { FormControlSizingSubTitle } from "../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const FormControlSizing = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FormControlSizingTitle} span={FormControlSizingSubTitle} />
        <CardBody>
          <Input bsSize="sm" type="text" placeholder=".form-control-sm" />
        </CardBody>
      </Card>
    </Col>
  );
};
export default FormControlSizing;
